import type { ReactNode } from "react";

/**
 * Standard page header: a title, a one-line **intent** subtitle ("what is the user here to do?"),
 * and optional right-aligned actions. Every dashboard page leads with one of these so the pages
 * read consistently and state their purpose in plain language.
 */
export function PageHeader({
  title,
  intent,
  actions,
}: {
  title: ReactNode;
  intent?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {intent && <p>{intent}</p>}
      </div>
      {actions && <div className="row wrap">{actions}</div>}
    </div>
  );
}
